export type WrappedPromise<T> = {
  promise: Promise<T>;
  resolve: (value: T) => void;
  reject: (reason: string) => void;
  reset: () => void;
};

export function createWrappedPromise<T = string | undefined>(): WrappedPromise<T> {
  let resolve: (value: T) => void;
  let reject: (reason: string) => void;

  const promise = new Promise<T>((res, rej) => {
    resolve = (value) => {
      res(value);
    };

    reject = (reason) => {
      rej(reason);
    };
  });

  const wrappedObject = {
    promise,
    // @ts-expect-error - TS doesn't know that resolve and reject are assigned
    resolve,
    // @ts-expect-error - TS doesn't know that resolve and reject are assigned
    reject,
    reset: () => {
      wrappedObject.promise = new Promise<T>((res, rej) => {
        const oldResolve = wrappedObject.resolve;
        const oldReject = wrappedObject.reject;

        // We need to resolve the old promise too when the new one is resolved after a reset
        wrappedObject.resolve = (value) => {
          oldResolve(value);
          res(value);
        };

        // We need to resolve the old promise too when the new one is resolved after a reset
        wrappedObject.reject = (reason) => {
          oldReject(reason);
          rej(reason);
        };
      });
    },
  };

  return wrappedObject;
}
